import { container, I18N_TOKEN } from '@/container';
import { addToast } from '@/stores/toast';

function fallbackCopyTextToClipboard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';
  textArea.style.opacity = '0';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand('copy');
    const msg = successful ? 'successful' : 'unsuccessful';
    console.info(`Fallback: Copying text command was ${msg}`);
  } catch (err) {
    console.error('unable to copy', err);
  } finally {
    document.body.removeChild(textArea);
  }

  return Promise.resolve();
}

export default async function copyTextToClipboard(value: string): Promise<void> {
  let text = value;
  const selection = document.getSelection();
  if (selection?.toString()) {
    text = selection.toString();
  }

  if (!navigator.clipboard) {
    await fallbackCopyTextToClipboard(text);
  } else {
    await navigator.clipboard.writeText(text);
  }

  addToast({ type: 'success', message: container.resolve(I18N_TOKEN).t('common.copy-success') });
}
